import { IconButton, Typography, MenuItem } from '@mui/material';
import Tabela from 'components/Tabela Grid';
import React, { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import _ from 'lodash'
import { Edit } from "@mui/icons-material";
import LaudoVisitaReportButton from '../LaudoVisitaList/LaudoVisitaReportButton';
import { Delete } from '@mui/icons-material';
import DialogAction from '../DialogAction';
import LaudoVisita from "entity/LaudoVisita";
import DropDownButton from 'components/DropDownButton';

export default function TabelaLaudos({ laudos, colunas, onStatusChange }) {
    const navigate = useNavigate()
    const [rowToModify, setRowToModify] = useState(null)
    const [open, setOpen] = useState(false)
    const [openCancelDialog, setOpenCancelDialog] = useState(false)
    const [itemToCancelFromDropdown, setItemToCancelFromDropdown] = useState(null)

    // status options
    const statusOptions = [
        { value: 'Concluído', label: 'Concluído' },
        { value: 'Cancelado', label: 'Cancelado' },
    ];

    const removeItem = (row) => {
        let entity = new LaudoVisita()
        entity.update({ uid: row.uid, status: 'Cancelado' })
        entity.save().then(() => {
            console.log('salvou reuniao')
            // callback to update the list
            if (onStatusChange) {
                onStatusChange();
            }
        })
    }

    const handleStatusChange = async (newStatus, linha) => {
        try {
            if (newStatus === 'Cancelado') {
                setItemToCancelFromDropdown(linha);
                setOpenCancelDialog(true);
                return;
            }

            const entity = new LaudoVisita();
            await entity.update({ uid: linha.uid, status: newStatus });
            await entity.save();
            console.log('Status atualizado para:', newStatus);

            // callback to update the list 
            if (onStatusChange) {
                onStatusChange();
            }
        } catch (error) {
            console.error('Erro ao atualizar status:', error);
        }
    }

    const confirmCancelFromDropdown = async (row) => {
        try {
            const entity = new LaudoVisita();
            await entity.update({ uid: row.uid, status: 'Cancelado' });
            await entity.save();
            console.log('Status atualizado para: Cancelado');

            // callback to update the list 
            if (onStatusChange) {
                onStatusChange();
            }
        } catch (error) {
            console.error('Erro ao cancelar laudo:', error);
        }
    }

    const openRemoveDialog = (props) => {
        setRowToModify(props.linha)
        setOpen(true)
    }

    const getValueSort = (linha, coluna) => {
        if ("COL_TABLE_ACTIONS" === coluna.field) {
            return "";
        }
        const parseValueShow = (value, linha, coluna) => {

            function detectDateString(dateString) {
                let parts = dateString.split('/')
                let date = null
                if (parts.length === 3) {
                    let day = parseInt(parts[0], 10)
                    let month = parseInt(parts[1], 10) - 1 // Mês começa de 0 (janeiro) até 11 (dezembro)
                    let year = parseInt(parts[2], 10)
                    date = new Date(year, month, day).getTime().toString() // converte data para milissegundos desde o epoch (01 de janeiro de 1970, 00:00:00 UTC)
                }

                return date
            }

            if (value) {
                if (value.constructor === String) {
                    let isValueActuallyDate = detectDateString(value)
                    if (isValueActuallyDate) {
                        value = isValueActuallyDate
                    }
                } else if (value.constructor === Number) {
                } else if (value.toDate) {
                    //timestamps                           net
                    value = value.toDate().toISOString();
                } else if (value.constructor === Object) {
                    if (coluna && coluna.funcToString) {
                        value = coluna.funcToString(value, linha, coluna);
                        value = parseValueShow(value, linha);
                    } else {
                        value = JSON.stringify(value);
                    }
                }
            }
            return value;
        };
        let value = _.get(linha, coluna.field);

        value = parseValueShow(value, linha, coluna);
        return value;
    };

    let colunasDefault = [
        { field: "COL_EDIT", label: "Ações", sizecol: "200" },
        { field: "sequencialIndex", label: "Visita Nº", sizecol: "80" },
        { field: "data", label: "Data da Visita", sizecol: "135" },
        { field: "cliente.nome", label: "Cliente" },
        { field: "fazenda.nomeFazenda", label: "Fazenda" },
        { field: "strIndicadores", label: "Indicadores", sizecol: "150" },
        { field: "tecnico.nome", label: "Técnico", sizecol: "150" },
        { field: "status", label: "Status", sizecol: "120" },
    ];

    const RenderCell = useCallback((props) => {
        const { coluna, linha, indexrow } = props;
        const editObj = (linha, indexrow) => {
            navigate("/visita?uid=" + linha.uid);
        };

        if ("COL_EDIT" === coluna.field) {
            return (
                <div style={{ display: "flex", justifyContent: "start", alignItems: "center", height: "100%", gap: "4px" }}>
                    <IconButton size="small" onClick={() => editObj(linha, indexrow)}>
                        <Edit />
                    </IconButton>
                    <LaudoVisitaReportButton uid={linha.uid} />
                    <IconButton onClick={() => openRemoveDialog(props)}>
                        <Delete />
                    </IconButton>
                    <DropDownButton>
                        {statusOptions.map((option) => (
                            <MenuItem
                                key={option.value}
                                onClick={() => handleStatusChange(option.value, linha)}
                                disabled={linha.status === option.value}
                            >
                                {option.label}
                            </MenuItem>
                        ))}
                    </DropDownButton>
                </div>
            );
        }

        if (coluna.Component) {
            return <coluna.Component {...props} />;
        }
        let value = _.get(linha, coluna.field);
        if (!value) {
            value = "";
        }
        if (coluna.field === "lastChange") {
        }

        if (value.toDate) {
            try {
                let dateV = value.toDate();
                var dia = dateV.getDate().toString();
                var diaF = dia.length === 1 ? "0" + dia : dia;
                var mes = (dateV.getMonth() + 1).toString(); //+1 pois no getMonth() Janeiro começa com zero.
                var mesF = mes.length === 1 ? "0" + mes : mes;
                var anoF = dateV.getFullYear();
                var hora = dateV.getHours() < 10 ? "0" + dateV.getHours() : dateV.getHours();
                var minuto = dateV.getMinutes() < 10 ? "0" + dateV.getMinutes() : dateV.getMinutes();
                var segundos = dateV.getSeconds() < 10 ? "0" + dateV.getSeconds() : dateV.getSeconds();
                value = diaF + "/" + mesF + "/" + anoF + " - " + hora + ":" + minuto + ":" + segundos;
            } catch (error) {
                value = "";
            }
        }

        return <Typography component="div">{value || ""}</Typography>;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleRowClick = (item) => {

        if (window.event?.ctrlKey || window.event?.metaKey) {
            // ctrl or cmd key is pressed, open in new tab
            const url = `#/visita?uid=${item.uid}`;
            window.open(url, '_blank');
        } else {
            console.log("onRowClick", item)
        }
    };

    return (
        <div style={{ flex: 1, }}>
            <Tabela
                sortColuns={true}
                getValueSort={getValueSort}
                data={laudos || []}
                columns={colunas || colunasDefault}
                msgSemRegistro={"Sem Registros"}
                onRowClick={handleRowClick}
                rowsPer={15}
                RenderCell={RenderCell}
            />

            <DialogAction
                open={open}
                setOpen={setOpen}
                statusCb={removeItem}
                row={rowToModify}
            />

            <DialogAction
                open={openCancelDialog}
                setOpen={setOpenCancelDialog}
                statusCb={confirmCancelFromDropdown}
                row={itemToCancelFromDropdown}
                title="Confirmar Cancelamento"
                message="Tem certeza que deseja cancelar este laudo?"
                confirmActionTitle="Confirmar Cancelamento"
                closeActionTitle="Sair"
            />
        </div>
    )
}
